import React from 'react';
import { Dialog } from './../../common/dialog';
import numeral from 'numeral';

const FormModal = React.memo((props) => {
    const hideHandler = () => {
        props.setIdModal(null, null, null);
        props.hideFormModal();
        props.resetApparelItemPart();
    };

    const handleFieldChange = (field, event) => {
        props.setApparelItemPartField(field, event.target.value);
    };

    let buttonLabel = 'Save';
    if (props.saving) {
        buttonLabel = <i className="fas fa-circle-notch fa-spin" />;
    }

    let price = 0;
    if (props.apparelItemPart) {
        const markupParsed = parseFloat(props.apparelItemPart.markup_parsed) / 100 + 1;
        price = (parseFloat(props.apparelItemPart.blank_cost) + parseFloat(props.apparelItemPart.decoration_cost) +
            parseFloat(props.apparelItemPart.sku_charge)) * markupParsed;
    }

    let fieldsDisabled = false;
    if (props.apparelItemPart.id) {
        fieldsDisabled = true;
    }

    let actions = [
        <button key="save-button" className="btn btn-light btn-sm action-button" onClick={props.saveApparelItemPart}>{buttonLabel}</button>,
        <button key="cancel-button" className="btn btn-light btn-sm action-button-cancel" onClick={hideHandler}>Close</button>
    ];
    return (
        <Dialog
            name="form-modal"
            modal={false}
            actions={actions}
            contentStyle={{ width: 1000 }}
            bodyStyle={{ overflow: 'initial' }}
            className="admin-apparel-item-parts-form-modal-dialog"
        >
            <div className="admin-apparel-item-parts-form-modal-container">
                <div className="title">Apparel Part</div>
                <div className="info-fields">
                    <div className="field size-field">
                        <div className="label">Size <span className="required">*</span>:</div>
                        <select value={props.apparelItemPart.size} onChange={handleFieldChange.bind(this, 'size')} disabled={fieldsDisabled} >
                            <option value="">Select option</option>
                            <option value="XS">Extra Small</option>
                            <option value="SM">Small</option>
                            <option value="MD">Medium</option>
                            <option value="LG">Large</option>
                            <option value="XL">Extra Large</option>
                            <option value="2XL">2XL</option>
                            <option value="3XL">3XL</option>
                            <option value="4XL">4XL</option>
                            <option value="5XL">5XL</option>
                            <option value="6XL">6XL</option>
                            <option value="7XL">7XL</option>
                            <option value="8XL">8XL</option>
                            <option value="ALL">One Size Fits All</option>
                        </select>
                    </div>
                    <div className="field logo-field">
                        <div className="label">Logo <span className="required">*</span>:</div>
                        <select value={props.apparelItemPart.logo} onChange={handleFieldChange.bind(this, 'logo')} disabled={fieldsDisabled} >
                            <option value="">Select option</option>
                            <option value="0">None</option>
                            <option value="1">UT Physician</option>
                            <option value="2">UTHealth</option>
                        </select>
                    </div>
                    <div className="field sku-field">
                        <div className="label">SKU <span className="required">*</span>:</div>
                        <input type="text" value={props.apparelItemPart.sku} onChange={handleFieldChange.bind(this, 'sku')} />
                    </div>
                    <div className="field lead-time-field">
                        <div className="label">Lead Time <span className="required">*</span>:</div>
                        <select value={props.apparelItemPart.lead_time} onChange={handleFieldChange.bind(this, 'lead_time')}>
                            <option value="">Select option</option>
                            <option value="7">One Week</option>
                            <option value="10">10 Days</option>
                            <option value="13">13 Days</option>
                            <option value="15">15 Days</option>
                            <option value="18">18 Days</option>
                            <option value="20">20 Days</option>
                        </select>
                    </div>
                    <div className="field current-inventory-field">
                        <div className="label">Current Inventory <span className="required">*</span>:</div>
                        <input type="text" value={props.apparelItemPart.inventory} onChange={handleFieldChange.bind(this, 'inventory')} />
                    </div>
                    <hr />
                    <div className="field blank-cost-field">
                        <div className="label">Blank Cost <span className="required">*</span>:</div>
                        <input type="text" placeholder="Cost" value={props.apparelItemPart.blank_cost} onChange={handleFieldChange.bind(this, 'blank_cost')} />
                    </div>
                    <div className="field decoration-cost-field">
                        <div className="label">Decoration Cost <span className="required">*</span>:</div>
                        <input type="text" placeholder="Cost" value={props.apparelItemPart.decoration_cost} onChange={handleFieldChange.bind(this, 'decoration_cost')} />
                    </div>
                    <div className="field customization-charge-field">
                        <div className="label">Customization Charge <span className="required">*</span>:</div>
                        <input type="text" placeholder="Cost" value={props.apparelItemPart.customization_charge} onChange={handleFieldChange.bind(this, 'customization_charge')} />
                    </div>
                    <div className="field markup-field">
                        <div className="label">Markup (%) <span className="required">*</span>:</div>
                        <input type="text" placeholder="Cost" value={props.apparelItemPart.markup_parsed} onChange={handleFieldChange.bind(this, 'markup_parsed')} />
                    </div>
                    <hr />
                    <div className="location-container">
                        <div className="title">Location</div>
                        <div className="fields">
                            <div className="field rack-field">
                                <div className="label">Rack:</div>
                                <input type="text" value={props.apparelItemPart.rack} onChange={handleFieldChange.bind(this, 'rack')} />
                            </div>
                            <div className="field row-field">
                                <div className="label">Row:</div>
                                <input type="text" value={props.apparelItemPart.row} onChange={handleFieldChange.bind(this, 'row')} />
                            </div>
                            <div className="field bin-field">
                                <div className="label">Bin:</div>
                                <input type="text" value={props.apparelItemPart.bin} onChange={handleFieldChange.bind(this, 'bin')} />
                            </div>
                        </div>
                    </div>
                    <div className="shipping-container">
                        <div className="title">Shipping</div>
                        <div className="fields">
                            <div className="field weight-field">
                                <div className="label">Product Weight:</div>
                                <input type="text" placeholder="lbs." value={props.apparelItemPart.weight} onChange={handleFieldChange.bind(this, 'weight')} />
                            </div>
                            <div className="field pieces-field">
                                <div className="label">Pieces/Per/Package:</div>
                                <input type="text" placeholder="Unit" value={props.apparelItemPart.pieces_per_package} onChange={handleFieldChange.bind(this, 'pieces_per_package')} />
                            </div>
                            <div className="field sku-charge-field">
                                <div className="label">SKU Charge <span className="required">*</span>:</div>
                                <input type="text" placeholder="Cost" value={props.apparelItemPart.sku_charge} onChange={handleFieldChange.bind(this, 'sku_charge')} />
                            </div>
                            <div className="field shipping-charge-field">
                                <div className="label">Shipping Charge <span className="required">*</span>:</div>
                                <input type="text" placeholder="Cost" value={props.apparelItemPart.shipping_charge} onChange={handleFieldChange.bind(this, 'shipping_charge')} />
                            </div>
                        </div>
                        <div className="preview-price text-right mt-2">
                            <strong>Price Preview:</strong> {numeral(price).format('$0,0.00')}
                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    );
});

export default FormModal;
